// "Found on your pages" (CT-028, REQ-10.9, module-4 2a): the places where the widget's automatic hiding hid
// something on an app's pages. Plain constants, so the server and the admin pages agree on them.

/** A find first seen within this many days is marked New in the list. */
export const NEW_FIND_DAYS = 7;

/** A find's description, the generated one or an owner's rename, is at most this many characters. */
export const MASKING_FIND_DESCRIPTION_MAX = 160;

/** Whether the widget hides the place (the default) or an owner allowed it (its screenshots leave it unmasked). */
export const MASKING_FIND_STATES = ['hidden', 'allowed'] as const;
export type MaskingFindState = (typeof MASKING_FIND_STATES)[number];
